import { HttpClient } from '@angular/common/http';
import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Material } from '../material';
import { Order } from '../order';
import { ShoppingcartService } from '../shoppingcart.service';
import { CityAndZip, Settlements } from './city-and-zip';
import { PersonalData } from './personal-data';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { RegistrationForm } from '../../login/registration-form';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../toastmessage/toastmessage.service';

@Component({
    selector: 'pw-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
    totalQuantity = 0;
    totalPrice = 0;
    materials: Material[] = [];
    isCompany = false;
    isIndividual = true;
    contactForm?: FormGroup;
    contactFormCompany?: FormGroup;
    form?: FormGroup;
    order?: Order = {};
    personalData?: PersonalData = {};
    cityAndZip?: CityAndZip = {};
    cityAndZipUrl = './assets/configurations/city-and-zip.json';
    cityName = '';
    wantToSignup = false;
    wantToRegisterText = '';
    wantToRegisterRadio = '';
    indeterminate = false;
    labelPosition = 'after';
    disabled = true;
    isTokenExists = false;
    getNewsOrNot = false;
    applyAszf = false;
    isAszfCheckBoxRed = false;
    errorMessage = '';
    registrationForm?: FormGroup;
    registrationObject?: RegistrationForm = {};
    passwordsAreNotEqual = '';
    passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])^((?![%]).)*$/;
    errorMessagee = '';

    passwordConfirm: string | undefined = '';

    password: string | undefined = '';

    isExtraSmall: Observable<BreakpointState>;
    isSmall: Observable<BreakpointState>;
    isMedium: Observable<BreakpointState>;

    hungarianPhonePrefix = '+36';

    phoneNumberPattern = '^(?:[0-9] ?){6,14}[0-9]$|^(\\+\\d{1,3}( )?)?((\\(\\d{3}\\))|\\d{3})[- .]?\\d{3}[- .]?\\d{4}$|^(\\+\\d{1,3}( )?)?(\\d{3}[ ]?){2}\\d{3}$|^(\\+\\d{1,3}( )?)?(\\d{3}[ ]?)(\\d{2}[ ]?){2}\\d{2}$';

    set checkBoxChecked(val) {
        this.wantToSignup = val;
        this.form!.get('updates')!.setValue(this.checkBoxChecked); // update your checbox control here
    }

    get checkBoxChecked() {
        return this.wantToSignup;
    }

    constructor(
        private readonly breakpointObserver: BreakpointObserver,
        private _fb: FormBuilder,
        private _fbCompany: FormBuilder,
        private _shoppingCartService: ShoppingcartService,
        private _router: Router,
        private _http: HttpClient,
        private _matDialog: MatDialog,
        private _toastMessageService: ToastmessageService
    ) {
        this.createForm();
        this.createRegistrationForm();
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);
        this.isSmall = this.breakpointObserver.observe(Breakpoints.Small);
        this.isMedium = this.breakpointObserver.observe(Breakpoints.Medium);
    }

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';

    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            this.isTokenExists = true;
        }
        this.form = this._fb.group({
            updates: [this.checkBoxChecked]
        });
        if (sessionStorage.getItem('registrationPassword')) {
            this.disabled = true;
        }

        const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        if (materials.length === 0) {
            this._router.navigateByUrl('/');
        }
        //this.materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        if (sessionStorage.getItem('personalData')) {
            this.personalData = JSON.parse(sessionStorage.getItem('personalData') as string) as PersonalData;
            this.cityName = this.personalData.settlement as string;
        }

        this.order = this._shoppingCartService.order;
        //this.calculateTotalPriceAndTotalQuantity();
        this._http.get<CityAndZip[]>(this.cityAndZipUrl).subscribe((cityAndZip) => {
            this.cityAndZip = cityAndZip as CityAndZip;
            this.cityAndZip.budapestStreets?.forEach((budapest) => {
                let settlement = new Settlements();
                settlement.city = 'Budapest';
                settlement.zipCode = budapest.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
            this.cityAndZip.debrecenStreets?.forEach((debrecen) => {
                let settlement = new Settlements();
                settlement.city = 'Debrecen';
                settlement.zipCode = debrecen.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
            this.cityAndZip.gyorStreets?.forEach((gyor) => {
                let settlement = new Settlements();
                settlement.city = 'Győr';
                settlement.zipCode = gyor.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
            this.cityAndZip.miskolcStreets?.forEach((miskolc) => {
                let settlement = new Settlements();
                settlement.city = 'Miskolc';
                settlement.zipCode = miskolc.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
            this.cityAndZip.pecsStreets?.forEach((pecs) => {
                let settlement = new Settlements();
                settlement.city = 'Pécs';
                settlement.zipCode = pecs.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
            this.cityAndZip.szegedStreets?.forEach((szeged) => {
                let settlement = new Settlements();
                settlement.city = 'Szeged';
                settlement.zipCode = szeged.zipCode;
                this.cityAndZip?.settlements?.push(settlement);
            });
        });
    }

    // calculateTotalPriceAndTotalQuantity() {
    //     this.materials.forEach((material) => {
    //         this.totalQuantity += material.quantity!;
    //         this.totalPrice += material.originalPrice!;
    //     });
    // }

    companyOrNot() {
        this.isCompany = true;
        this.isIndividual = false;
    }
    individual() {
        this.isCompany = false;
        this.isIndividual = true;
    }

    goToDeliveryIndividual() {
        sessionStorage.setItem('wantToSignup', JSON.stringify(this.wantToSignup));

        if (!sessionStorage.getItem('personalData')) {
            this.collectIndividualData();
        }
        else {
            if (this.isPhoneNumberValid(this.personalData?.phoneNumber!)) {
                this._router.navigateByUrl('/delivery');
            }
        }
    }

    goToDeliveryCompany() {
        sessionStorage.setItem('wantToSignup', JSON.stringify(this.wantToSignup));

        if (!sessionStorage.getItem('personalData')) {
            this.collectCompanyData();
        } else {
            if (this.isPhoneNumberValid(this.personalData?.phoneNumber!)) {
                this._router.navigateByUrl('/delivery');
            }
        }
    }

    goToDeliveryIndividualRegister() {
        sessionStorage.setItem('wantToSignup', JSON.stringify(this.wantToSignup));
        this.confirmPassword();
        if (this.passwordConfirm === this.password) {
            if (!sessionStorage.getItem('personalData')) {
                this.collectIndividualData();
            } else {
                if (this.isPhoneNumberValid(this.personalData?.phoneNumber!)) {
                    this._router.navigateByUrl('/delivery');
                }
            }
        }

    }

    goToDeliveryCompanyRegister() {
        sessionStorage.setItem('wantToSignup', JSON.stringify(this.wantToSignup));
        this.confirmPassword();
        if (this.passwordConfirm === this.password) {
            if (!sessionStorage.getItem('personalData')) {
                this.collectCompanyData();
            } else {
                if (this.isPhoneNumberValid(this.personalData?.phoneNumber!)) {
                    this._router.navigateByUrl('/delivery');
                }
            }
        }
    }

    createForm() {
        this.createIndividualAndCompanyForms();
    }

    createIndividualAndCompanyForms() {

        //"^(?:[0-9] ?){6,14}[0-9]$|^(\\+\\d{1,3}( )?)?((\\(\\d{3}\\))|\\d{3})[- .]?\\d{3}[- .]?\\d{4}$|^(\\+\\d{1,3}( )?)?(\\d{3}[ ]?){2}\\d{3}$|^(\\+\\d{1,3}( )?)?(\\d{3}[ ]?)(\\d{2}[ ]?){2}\\d{2}$"-phoneNumberRegex
        this.contactForm = this._fb.group({
            firstName: ['', [Validators.required, Validators.minLength(3)]],
            lastName: ['', [Validators.required, Validators.minLength(3)]],
            email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            zipCode: ['', [Validators.required, Validators.pattern('[0-9]{4}')]],
            settlement: ['', [Validators.required, Validators.minLength(3)]],
            address: ['', Validators.required],
            phoneNumber: ['', [Validators.required,Validators.pattern(this.phoneNumberPattern)]]
        });

        this.contactFormCompany = this._fbCompany.group({
            companyName: ['', [Validators.required, Validators.minLength(3)]],
            firstName: ['', [Validators.required, Validators.minLength(3)]],
            lastName: ['', [Validators.required, Validators.minLength(3)]],
            companyEmail: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            vatNumber: ['', Validators.required],
            companyZipCode: ['', [Validators.required, Validators.pattern('[0-9]{4}')]],
            companySettlement: ['', [Validators.required, Validators.minLength(3)]],
            companyAddress: ['', Validators.required],
            phoneNumber: ['', [Validators.required,Validators.pattern(this.phoneNumberPattern)]]
        });
    }
    collectIndividualData() {
        if (this.isPhoneNumberValid(this.contactForm?.controls['phoneNumber'].value)) {
            this.personalData = {
                isCompany: this.isCompany,
                email: this.contactForm?.controls['email'].value as string | undefined,
                firstName: this.contactForm?.controls['firstName'].value as string | undefined,
                lastName: this.contactForm?.controls['lastName'].value as string | undefined,
                zipCode: this.contactForm?.controls['zipCode'].value as number | undefined,
                settlement: this.contactForm?.controls['settlement'].value as string | undefined,
                address: this.contactForm?.controls['address'].value as string | undefined,
                phoneNumber: this.contactForm?.controls['phoneNumber'].value as string | undefined
            };

            if (this._shoppingCartService.order) {
                this._shoppingCartService.order.personalData = this.personalData;
                sessionStorage.setItem('personalData', JSON.stringify(this.personalData));
            }
            this._router.navigateByUrl('/delivery');
        }

    }
    collectCompanyData() {
        if (this.isPhoneNumberValid(this.contactForm?.controls['phoneNumber'].value)) {
            this.personalData = {
                isCompany: this.isCompany,
                email: this.contactFormCompany?.controls['companyEmail'].value as string | undefined,
                companyName: this.contactFormCompany?.controls['companyName'].value as string | undefined,
                firstName: this.contactFormCompany?.controls['firstName'].value as string | undefined,
                lastName: this.contactFormCompany?.controls['lastName'].value as string | undefined,
                taxNumber: this.contactFormCompany?.controls['vatNumber'].value as string | undefined,
                zipCode: this.contactFormCompany?.controls['companyZipCode'].value as number | undefined,
                settlement: this.contactFormCompany?.controls['companySettlement'].value as string | undefined,
                address: this.contactFormCompany?.controls['companyAddress'].value as string | undefined,
                phoneNumber: this.contactFormCompany?.controls['phoneNumber'].value as string | undefined
            };

            if (this._shoppingCartService.order) {
                this._shoppingCartService.order.personalData = this.personalData;
                sessionStorage.setItem('personalData', JSON.stringify(this.personalData));
            }

            this._shoppingCartService.isCompany = true;
            this._router.navigateByUrl('/delivery');
        }
    }

    loadCity(zip: string) {
        this.cityAndZip?.settlements?.forEach((value) => {
            if (value.zipCode === Number(zip)) {
                this.cityName = value.city as string;
            }
        });
    }

    wantToRegister() {
        this.wantToSignup = !this.wantToSignup;
    }

    collectIndividualDataToRegister() {
        this.personalData = {
            isCompany: this.isCompany,
            email: this.contactForm?.controls['email'].value as string | undefined,
            firstName: this.contactForm?.controls['firstName'].value as string | undefined,
            lastName: this.contactForm?.controls['lastName'].value as string | undefined,
            zipCode: this.contactForm?.controls['zipCode'].value as number | undefined,
            settlement: this.contactForm?.controls['settlement'].value as string | undefined,
            address: this.contactForm?.controls['address'].value as string | undefined,
            phoneNumber: this.contactForm?.controls['phoneNumber'].value as string | undefined
        };

        if (this._shoppingCartService.order) {
            this._shoppingCartService.order.personalData = this.personalData;
            sessionStorage.setItem('personalData', JSON.stringify(this.personalData));
        }
    }

    collectCompanyDataToRegister() {
        this.personalData = {
            isCompany: this.isCompany,
            email: this.contactFormCompany?.controls['companyEmail'].value as string | undefined,
            companyName: this.contactFormCompany?.controls['companyName'].value as string | undefined,
            firstName: this.contactFormCompany?.controls['firstName'].value as string | undefined,
            lastName: this.contactFormCompany?.controls['lastName'].value as string | undefined,
            taxNumber: this.contactFormCompany?.controls['vatNumber'].value as string | undefined,
            zipCode: this.contactFormCompany?.controls['companyZipCode'].value as number | undefined,
            settlement: this.contactFormCompany?.controls['companySettlement'].value as string | undefined,
            address: this.contactFormCompany?.controls['companyAddress'].value as string | undefined,
            phoneNumber: this.contactFormCompany?.controls['phoneNumber'].value as string | undefined
        };

        if (this._shoppingCartService.order) {
            this._shoppingCartService.order.personalData = this.personalData;
            sessionStorage.setItem('personalData', JSON.stringify(this.personalData));
        }

        this._shoppingCartService.isCompany = true;
    }



    createRegistrationForm() {
        this.registrationForm = this._fb.group({
            password: ['', [Validators.required, Validators.pattern(this.passwordRegex)]],
            passwordConfirm: ['', [Validators.required, Validators.pattern(this.passwordRegex)]]
        });
    }

    confirmPassword() {
        this.password = this.registrationForm?.controls['password'].value as string | undefined;
        this.passwordConfirm = this.registrationForm?.controls['passwordConfirm'].value as string | undefined;
        if (this.password === this.passwordConfirm) {
            this.registrationObject = {
                password: this.registrationForm?.controls['password'].value as string | undefined
            };
            sessionStorage.setItem('registrationPassword', JSON.stringify(this.registrationObject));
        } else {
            this.errorMessage = 'Nem egyeznek a jelszavak!';
        }
    }

    isPhoneNumberValid(phoneNumber: string): boolean {
        if (phoneNumber.substring(0, 2) === '06' || phoneNumber.substring(0, 3) === '+36' || phoneNumber.substring(0, 4) === '0036') {
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, 'A telefonszám első karakterei nem tartalmazhatják a "06", "+36" és "0036" előhívószámokat!', MAT_ICON.warning);
            this.dismissError();
            return false;

        }
        return true
    }


    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }
}
